import api from '../../api/index';
import router from '../../router';

export default {
  namespaced: true,
  state     : {
    users_employees_table: {
      content: {
        pagination: {
          rowsPerPage: localStorage.getItem('paginationValueTrainingManagement') || 10,
          sortBy     : 'fio',
          totalItems : 10,
          descending : false,
        },
        headers: [
          {text: 'ФИО', value: 'fio', sort: true, width: '200px'},
          {text: 'Организация', value: 'organizationName', sort: true, width: '277px'},
          {text: 'Курс', value: 'course', sort: true, width: '233px'},
          {text: 'Дата назначения', value: 'appointmentDate', sort: true, width: '191px'},
          {text: 'Дата окончания', value: 'expirationDate', sort: true, width: '191px'},
          {text: 'Дата сдачи', value: 'completionDate', sort: true, width: '250px'},
          {text: '%, выполнения', value: 'completionPercent', sort: true, width: '148px'},
          {text: '', value: 'action', sort: false, width: '80px'},
        ],
        body: [],
      },
    },
    search_string                  : '',
    users_pages                    : 0,
    page                           : 1,
    org_filter                     : '',
    appointment_date_filter        : '',
    training_completion_date_filter: '',
    test_id_filter                 : '',
    users_filters                  : undefined,
  },
  getters: {
    page                           : ({page}) => page,
    users_pages                    : ({users_pages}) => users_pages,
    search_string                  : ({search_string}) => search_string,
    org_filter                     : ({org_filter}) => org_filter,
    users_filters                  : ({users_filters}) => users_filters,
    appointment_date_filter        : ({appointment_date_filter}) => appointment_date_filter,
    training_completion_date_filter: ({training_completion_date_filter}) => training_completion_date_filter,
    test_id_filter                 : ({test_id_filter}) => test_id_filter,
    users_employees_table          : ({users_employees_table}) => users_employees_table,
    get_id_by_organization         : ({users_filters}) => (role) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.organizations.find((item) => {
          return item.text === role;
        });
      }

      return answer;
    },
    get_id_by_role: ({users_filters}) => (role) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.roles.find((item) => {
          return item.text === role;
        });
      }

      return answer;
    },
    get_role_by_id: ({users_filters}) => (id) => {
      let answer = {};

      if (users_filters !== undefined) {
        answer = users_filters.roles.find((item) => {
          return parseInt(item.id) === id;
        });
      }

      return answer;
    },
  },
  mutations: {
    RESET_EMPLOYEES_FILTERES(state) {
      state.org_filter = '';
      state.appointment_date_filter = '';
      state.training_completion_date_filter = '';
      state.test_id_filter = '';
      state.users_employees_table.content.pagination.sortBy = '';
      state.users_employees_table.content.pagination.descending = '';
    },
    SET_EMPLOYEES_PAGINATION(state, value) {
      state.users_employees_table.content.pagination = value;
    },
    SHOW_NUMBER(state, selected) {
      let selectedTable = state.users_employees_table.content;

      if (selected=='Показывать по 10') {
        selectedTable.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        selectedTable.pagination.rowsPerPage = 25;
      } else if (selected=='Показывать по 50') {
        selectedTable.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        selectedTable.pagination.rowsPerPage = 100;
      }
    },
    SET_PAGE(state, value) {
      state.page = value;
    },
    SEARCH_EMPLOYEE(state, value) {
      state.search_string = value;
    },
    SET_ORG_FILTER(state, value) {
      state.org_filter = value;
    },
    SET_TRAINING_COMPLETION_DATE_FILTER(state, value) {
      state.training_completion_date_filter = value;
    },
    SET_TEST_ID_FILTER(state, value) {
      state.test_id_filter = value;
    },
    SET_APPOINTMENT_DATE_FILTER(state, value) {
      state.appointment_date_filter = value;
    },
    SET_PAGES_COUNT(state, value) {
      state.users_pages = value;
    },
    CHANGE_EMPLOYEES_SORT(state, column) {
      let selectedTable = state.users_employees_table.content;
      if (selectedTable.pagination.sortBy === column) {
        selectedTable.pagination.descending = !selectedTable.pagination.descending;
      } else {
        selectedTable.pagination.sortBy = column;
        selectedTable.pagination.descending = false;
      }
    },
    ADD_USER(state, user) {
      state.users_employees_table.content.body.push(user);
    },
    SET_USERS(state, value) {
      if (value) {
        state.users_employees_table.content.body = value;
        state.users_employees_table.content.body.forEach((x) => {
          x.date = x.date * 1000;
        });
      } else {
        state.users_employees_table.content.body = [];
      }
    },
    SET_USERS_FILTERS(state, value) {
      state.users_filters = value;
    },
    CHANGE_USERS_FILTERS(state, value) {
      state.users_filters = value;
    },
  },
  actions: {
    async update_completed_courses({state, dispatch}, inject = {}) {
      let pagination = localStorage.getItem('paginationValueTrainingManagement') || 10;
      let obj = Object.assign({
        page_size               : pagination,
        page_num                : 1,
        organization            : state.org_filter,
        appointment_date        : state.appointment_date_filter,
        training_completion_date: state.training_completion_date_filter,
        courseId                : state.test_id_filter,
        name                    : state.search_string,
      }, inject);

      await dispatch('get_all_organizations_courses', obj);
      await dispatch('get_completed_courses', obj);
    },
    async get_all_organizations_courses({commit}) {
      try {
        const allOrganizationCourses = await api.tests.get_all_organizations_courses();

        commit('SET_USERS_FILTERS', allOrganizationCourses.data);
      } catch (error ) {
        console.error(error);
      }
    },
    async get_completed_courses({commit, state}, obj) {
      let sortBy = state.users_employees_table.content.pagination.sortBy;
      let sortOrder = state.users_employees_table.content.pagination.descending ? 'desc' : 'asc';


      try {
        const completedCourses = await api.tests.get_completed_courses({...obj, sortBy, sortOrder});

        commit('SET_USERS', completedCourses.data.data || []);
        commit('SET_PAGES_COUNT', completedCourses.data.pagination.pages);
      } catch (err) {
        if (err.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async delete_assigned_test(_, testIds = []) {
      try {
        await api.tests.delete_assigned_test(testIds);
      } catch (error) {
        if (error.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
